import { NgModule } from '@angular/core'
import { ConsoleComponent } from './console.component'
import {DragDropModule} from '@angular/cdk/drag-drop'
import { MatIconModule } from '@angular/material/icon';
import {FormsModule} from '@angular/forms'
import {CommonModule} from '@angular/common'

@NgModule({
    declarations: [
        ConsoleComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        MatIconModule,
    ],
    exports: [
        ConsoleComponent
    ],
    providers: []
})
export class ConsoleModule {}
